import AccountPage from 'src/account';
import { AccountLayout } from 'src/components/layouts/account-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(AccountPage, AccountLayout);
